// components/shared/GlobalLoader.tsx
"use client";

import { AnimatePresence, motion } from "framer-motion";
import Logo from "@/components/layout/Logo";

export default function GlobalLoader({ show }: { show: boolean }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="route-loader"
          role="status"
          aria-live="polite"
          className="fixed inset-0 z-[999] flex items-center justify-center bg-background/70 backdrop-blur"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {/* Logo container */}
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.96, opacity: 0 }}
            transition={{ duration: 0.25, ease: [0.16, 0.84, 0.44, 1] }}
            className="flex flex-col items-center"
          >
            {/* Spinning / pulsing logo */}
            <motion.div
              animate={{ rotate: [0, 6, -6, 0], scale: [1, 1.03, 1] }}
              transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
            >
              <Logo hideTitle />
            </motion.div>

            {/* Subtle progress bar */}
            <motion.div
              className="mt-6 h-1 w-40 overflow-hidden rounded-full bg-muted"
              initial={false}
            >
              <motion.div
                className="h-full w-1/3 bg-primary"
                animate={{ x: ["-50%", "120%"] }}
                transition={{ duration: 1.1, repeat: Infinity, ease: "easeInOut" }}
              />
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
